/* ============================================================
   THE FLAG
   ============================================================

   One switch decides which public website your users get.

       true   ->  the NEW landing site serves every public page
                  (home, marketing, pricing, auth, forms, download,
                   legacy URLs — the full list is routes.manifest.js)

       false  ->  the CURRENT site serves everything, exactly as it
                  does today. The new module renders nothing at all.

   Either way the app itself — /dashboard, /billing, /main-admin,
   /partner, CRM, HRMS — is untouched. Those URLs are not in the
   manifest, so they always go to your existing code.

   Flip it, rebuild, deploy. Nothing else changes.
   ------------------------------------------------------------
   Want to check the new site in production before committing?
   Override it in the browser console, no rebuild needed:

       localStorage.setItem('tg_landing_v2', 'true');   // new site
       localStorage.setItem('tg_landing_v2', 'false');  // old site
       localStorage.removeItem('tg_landing_v2');        // back to the flag

   Or set window.__TG_LANDING_V2__ before React mounts (e.g. from a
   server-rendered <script> tag) to roll out per-cohort.
   ============================================================ */

export const LANDING_V2_DEFAULT = true;

function readOverride() {
  try {
    if (typeof window === 'undefined') return null;
    if (typeof window.__TG_LANDING_V2__ === 'boolean') return window.__TG_LANDING_V2__;
    const raw = window.localStorage?.getItem('tg_landing_v2');
    if (raw === 'true') return true;
    if (raw === 'false') return false;
    return null;
  } catch {
    return null;
  }
}

const override = readOverride();

/** The resolved answer: does the new landing site serve the public pages? */
export const LANDING_V2 = override === null ? LANDING_V2_DEFAULT : override;

/* ------------------------------------------------------------------
   Kept for compatibility with anything that imported the old grouped
   config. Everything now follows the single flag, so a page either
   belongs to the new site or it doesn't.
   ------------------------------------------------------------------ */
export const LANDING = {
  enabled: LANDING_V2,
  marketing: LANDING_V2,
  auth: LANDING_V2,
  forms: LANDING_V2,
  download: LANDING_V2,
  redirects: LANDING_V2,
};

export default LANDING;
